import {
  extensionFunctionType,
  extensionWebhookType,
  HookType,
} from '@rossum/api-client/hooks';
import { connect } from 'react-redux';
import { State } from '../../../../../types/state';
import { CreateExtension as CreateExtensionForm } from './components/CreateExtension';

const isExtensionType = (type: string): type is HookType =>
  [extensionWebhookType, extensionFunctionType].includes(type);

type StateProps = {
  defaultExtensionType: HookType | undefined;
};

const mapStateToProps = (state: State): StateProps => {
  const extensionTypeHash = state.router.location.hash;

  const maybeDefaultExtensionType =
    extensionTypeHash && extensionTypeHash.split('#')[1];

  const defaultExtensionType =
    maybeDefaultExtensionType && isExtensionType(maybeDefaultExtensionType)
      ? maybeDefaultExtensionType
      : undefined;

  return {
    defaultExtensionType,
  };
};

export const CreateExtension = connect(mapStateToProps)(CreateExtensionForm);
